import { createSelector } from 'reselect'
import { getIsLuxLoyaltyEnabled } from './luxLoyaltyFeatureToggles'
import { selectLoggedIn } from 'selectors/accountSelectors'

const getCanLoyaltyEnrollExistingUser = createSelector(
  (state: App.State) => getIsLuxLoyaltyEnabled(state),
  (state: App.State) => selectLoggedIn(state),
  (state: App.State) => state.luxLoyalty.account,
  (
    loyaltyEnabled,
    isLoggedIn,
    loyaltyAccount,
  ): boolean => {
    if (!loyaltyEnabled || !isLoggedIn) return false
    if (loyaltyAccount.fetching || loyaltyAccount.error) return false
    return !loyaltyAccount.data
  },
)

export default getCanLoyaltyEnrollExistingUser
